import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getPieChartData } from "../../api";

function TransactionPieChart({ powerappId, selectedYear }) {
    const [noData, setNoData] = useState(true);
    const [series, setSeries] = useState([25, 25, 25, 25]);
    const [options, setOptions] = useState({
        chart: {
            width: 500,
            type: "pie",
        },
        labels: ["Team A", "Team B", "Team C", "Team D"],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: "bottom",
                    },
                },
            },
        ],
    });

    useEffect(() => {
        getPieChartData({
            powerapp_id: powerappId,
            year: selectedYear,
        }).then((res) => {
            if (res.status) {
                setSeries(res.data);
                setOptions({
                    chart: {
                        width: 500,
                        type: "pie",
                    },
                    labels: res.label,
                    responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200,
                                },
                                legend: {
                                    position: "bottom",
                                },
                            },
                        },
                    ],
                });

                const sum = res.data.reduce(
                    (accumulator, currentValue) => +accumulator + +currentValue,
                    0,
                );
                if (sum > 0) {
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            }
        });
    }, [selectedYear]);

    return (
        <div>
            {noData ? (
                <></>
            ) : (
                <ReactApexChart options={options} series={series} type="pie" />
            )}
        </div>
    );
}

export default TransactionPieChart;
